const PATH_MAPPINGS = {
	'/portal/hu/otpdirekt/kilepes': {
		promoName: 'Kilépő oldali ajánlatok',
		promoPosition: 'kilepo-ajanlatok-'
	},
	'/portal/hu/internetbank/kilepes': {
		promoName: 'IB Kilépő oldali ajánlatok',
		promoPosition: 'ib-kilepo-ajanlatok-'
	},
	'/portal/hu/maganszemelyek': {
		promoName: 'Főoldali ajánlat - promobox',
		promoPosition: 'fooldali-ajanlat-promobox-'
	},
	'/portal/en/internetbank/logout': {
		promoName: 'IB EN oldali ajánlat - promobox',
		promoPosition: 'ib-en-ajanlat-promobox-'
	},
	'/portal/hu/mkv': {
		promoName: 'MKV oldali ajánlat - promobox',
		promoPosition: 'mkv-ajanlat-promobox-'
	}
};

export const getPagePath = () => {
	return window.location.pathname.toLowerCase();
};

export const getPromotionNameAndSlot = (pagePath) => {
	return (
		PATH_MAPPINGS[pagePath] || {
			promoName: 'További ajánlatok' + pagePath,
			promoPosition: 'tovabbi-ajanlatok-' + pagePath
		}
	);
};

export const getHeroCreativeSlot = (pagePath) => {
	if (pagePath === '/portal/hu/mkv') {
		return 'mkv main banner';
	}
	return 'portal main banner';
};

export const extractImageFilename = (fragmentHtml) => {
	if (!fragmentHtml) return '';
	const imgMatch = fragmentHtml.match(/<img[^>]*src="([^"]*)"/i);
	if (imgMatch) {
		return imgMatch[1].replace(/^(.*[\\/])/, '').replace(/_(?:.(?!_))+$/, '');
	}
	const sourceMatch = fragmentHtml.match(/<source[^>]*srcset="([^"]*)"/i);
	if (sourceMatch) {
		return sourceMatch[1].replace(/^(.*[\\/])/, '').replace(/_(?:.(?!_))+$/, '');
	}
	return '';
};

export const extractHeroTitle = (fragmentHtml) => {
	if (!fragmentHtml) return '';
	const h1Match = fragmentHtml.match(/<h1[^>]*class="[^"]*mher-title[^"]*"[^>]*>(.*?)<\/h1>/i);
	if (h1Match) {
		const textContent = h1Match[1]
			.replace(/<[^>]*>/g, '')
			.replace(/&nbsp;/g, ' ')
			.replace(/\n/g, ' ')
			.trim();
		return textContent;
	}
	return '';
};

export const extractH3Title = (fragmentHtml) => {
	if (!fragmentHtml) return '';
	const h3Match = fragmentHtml.match(/<h3[^>]*>(.*?)<\/h3>/i);
	if (h3Match) {
		const textContent = h3Match[1]
			.replace(/<[^>]*>/g, '')
			.replace(/&nbsp;/g, ' ')
			.replace(/\n/g, ' ')
			.trim();
		return textContent;
	}
	return '';
};

export const sendViewPromotionGtm = (vm, promotionData) => {
	if (!vm || !vm.$gtm) return;

	vm.$gtm.trackEvent({
		event: 'viewPromotion',
		ecommerce: {
			items: [
				{
					promotion_id: promotionData.promotion_id,
					promotion_name: promotionData.promotion_name,
					creative_name: promotionData.creative_name,
					creative_slot: promotionData.creative_slot,
					promotion_module: promotionData.promotion_module,
					promotion_model: promotionData.promotion_model
				}
			]
		}
	});
};

export const sendSelectPromotionGtm = (vm, promotionData) => {
	if (!vm || !vm.$gtm) return;

	vm.$gtm.trackEvent({
		event: 'selectPromotion',
		ecommerce: {
			items: [
				{
					promotion_id: promotionData.promotion_id,
					promotion_name: promotionData.promotion_name,
					creative_name: promotionData.creative_name,
					creative_slot: promotionData.creative_slot,
					promotion_module: promotionData.promotion_module,
					promotion_model: promotionData.promotion_model
				}
			]
		}
	});
};
